import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase.js";
import Seo from "./Seo.jsx";
import "../admin.css";

function AdminShell({ title, subtitle, backLabel, backTo, children }) {
  const navigate = useNavigate();
  const [signingOut, setSigningOut] = useState(false);

  async function handleSignOut() {
    try {
      setSigningOut(true);
      await signOut(auth);
      navigate("/login");
    } finally {
      setSigningOut(false);
    }
  }

  return (
    <div className="admin-layout">
      <Seo noindex title={`${title} | Pentagon Properties`} />
      <header className="custom-navbar admin-navbar">
        <div className="custom-container admin-navbar__container">
          <Link className="custom-brand" to="/">
            Pentagon Properties
          </Link>
          <div className="admin-navbar__actions">
            <Link className="admin-navbar__link" to="/">
              Home
            </Link>
            <Link className="admin-navbar__link" to="/admin">
              Admin
            </Link>
            {backTo ? (
              <Link className="admin-navbar__link" to={backTo}>
                {backLabel || "Back"}
              </Link>
            ) : null}
            <button
              className="admin-navbar__button"
              disabled={signingOut}
              onClick={handleSignOut}
              type="button"
            >
              {signingOut ? "Signing Out..." : "Sign Out"}
            </button>
          </div>
        </div>
      </header>

      <main className="admin-page">
        <section className="admin-page__hero">
          <div className="admin-page__hero-copy">
            <p className="admin-page__eyebrow">Photo Admin</p>
            <h1>{title}</h1>
            {subtitle ? <p className="admin-page__subtitle">{subtitle}</p> : null}
          </div>
        </section>

        <section className="admin-page__content">{children}</section>
      </main>
    </div>
  );
}

export default AdminShell;
